export class AreaType {
    static readonly administrative = 'administrative'
    static readonly circle = 'circle'
    static readonly custom = 'custom'
}


// WEBPACK FOOTER //
// /app/src/shared/constants/area-type.ts